import Reveal from '@/components/base/Reveal';

export default function SubmitSection() {
  return (
    <section id="submit" className="w-full bg-background-50 pb-20 md:pb-28">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-primary-700 px-6 py-14 md:px-14 md:py-16">
            <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl" />
            <div className="relative z-10 grid grid-cols-1 gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
              <div>
                <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-background-100/80">
                  <span className="h-px w-6 bg-accent-400" />
                  05 / 线索入口
                </div>
                <h3 className="mt-4 font-heading text-[28px] font-black leading-tight text-background-50 md:text-[38px]">
                  手里有猛料？直接丢过来
                </h3>
                <p className="mt-4 max-w-[560px] text-[15px] leading-relaxed text-background-100/85">
                  线索入口同样免费开放，不收取任何费用，也不需要注册账号。编辑团队核实后会整理发布，
                  必要时可以完全匿名。
                </p>
                <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                  <button
                    type="button"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-7 py-3.5 text-[15px] font-medium text-primary-700 transition-colors hover:bg-background-100"
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className="ri-send-plane-line text-[18px]" />
                    </span>
                    提交爆料线索
                  </button>
                  <button
                    type="button"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3.5 text-[15px] font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className="ri-customer-service-2-line text-[18px]" />
                    </span>
                    联系编辑
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 lg:grid-cols-1 lg:gap-3">
                {[
                  { icon: 'ri-shield-check-line', title: '完全公开', desc: '无需付费，不限量看' },
                  { icon: 'ri-lock-2-line', title: '隐私保护', desc: '支持匿名提交线索' },
                  { icon: 'ri-timer-flash-line', title: '快速响应', desc: '平均 24 小时内核实' },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="flex items-start gap-3 rounded-lg border border-background-50/15 bg-primary-800/60 p-4"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                      <i className={`${item.icon} text-[18px]`} />
                    </span>
                    <div>
                      <div className="text-[14px] font-medium text-background-50">{item.title}</div>
                      <div className="mt-0.5 text-[12px] text-background-100/70">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}